import { IComponent, IRegistryOptions } from '../../../../interfaces/src/lib/interfaces/index';

export class AEMRegistry {
  private registry: Map<string, IComponent>;
  public renderMissingAEMComponents: boolean;

  constructor({ renderMissingAEMComponents = false }: IRegistryOptions = {}) {
    this.registry = new Map();
    this.renderMissingAEMComponents = renderMissingAEMComponents;
  }

  register(component: IComponent): void {
    if (component) {
      if (Array.isArray(component.aemResourceType)) {
        component.aemResourceType.forEach((resourceType: string) => {
          this.registry.set(resourceType, component);
        });
      } else {
        this.registry.set(component.aemResourceType, component);
      }
    }
  }

  getComponent(name: string): IComponent | undefined {
    let nameWithoutAppStart = name;
    if (/^\/?apps\//.test(name)) {
      nameWithoutAppStart = name.replace(/^\/?apps\//, '');
    }

    return this.registry.get(nameWithoutAppStart);
  }
}

export const createAemRegistry = (renderMissingAEMComponents = false, wrappers = []) => {
  const aemRegistry = new AEMRegistry({ renderMissingAEMComponents });

  // load all modules and register the AEM components
  wrappers.forEach((wrapperComponent) => aemRegistry.register(wrapperComponent));

  return aemRegistry;
};
